import { AuthIntermediateMonitoringService, Brand, Stage, MonitoringServiceOptions } from '@mamdev/navigator.epimetheus'
import { error } from '@mamdev/navigator.frontend-logger'
import { getUrlParam } from './url-param'
import { getStage } from './stage'
import { getBrand } from './brand'

export function initMonitoring(metaData?: MonitoringServiceOptions['metaData']) {
  let brand = getBrand().replace(/\./g, '') as Brand
  if (brand.startsWith('gmx')) {
    brand = 'gmx'
  }

  try {
    const service = new AuthIntermediateMonitoringService({
      brand,
      stage: getStage() as Stage,
      metaData: {
        section: getUrlParam('section'),
        ...metaData,
      }
    })
    setMonitoringService(service)
  } catch (e) {
    error('Error while initializing monitoring service', e)
  }

}

let ms: AuthIntermediateMonitoringService

export function setMonitoringService(monitoringService: AuthIntermediateMonitoringService) {
  ms = monitoringService
}

// expose the service as a singleton
export function getMonitoringService() {
  return ms
}
